import { Reducer } from "redux";

import { LanguageMasterResponse } from "../models/Api/MemberDetails";
import { LanguageDispatchTypes } from "../models/DispatchTypes/MemberDetails";
import { LanguageMasterActionDispatchTypes } from "../constants/MemberDetails";

export const initialState: LanguageMasterResponse = {
  loading: false,
  response: [],
};

const MasterLanguageReducer: Reducer<
  LanguageMasterResponse,
  LanguageDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case LanguageMasterActionDispatchTypes.LANGUAGE_MASTER_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case LanguageMasterActionDispatchTypes.LANGUAGE_MASTER_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
  }
  return state;
};

export default MasterLanguageReducer;
